import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/common/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

    public selectedProcess: any;
    public wizard: any = {};
    public selectedControl: any;
    public selectedStep: any;
    public referentials: any;
    public selectedClient: any;
    public isCompany: any;
    public userAction: any;
    requiredControls: Array<string> = [];

    public clientProcesseCodes: any;
    public clientNewOffer: string;
    public clientNewLead: string;
    public clientNewPolicy: string;
    public clientNewClient: string;
    public clientConsultation: string;
    public clientModification: string;

    constructor(private apiService: ApiService) {

        this.wizard.Steps = {
            "1": {
                "Code": "1",
                "Text": "Client Details",
                "Codes": [],
                "GroupCodes": [],
                "Controls": {},
                "ControlGroups": {},
                "Type": "Standard"
            }
        };

        this.userAction = "";

        this.getClientProcesses();

    }

    getClientProcesses() {
        //get the client process codes from SYSCONTROL table
        var model = {
            ClientKey: "",
        };

        this.apiService.post("Api/ClientTemplateApi/SearchClientProcesses/", model).subscribe((res) => {
            this.clientProcesseCodes = res;

            this.clientNewOffer = res["CLIENT_NEWOFFER"];
            this.clientNewLead = res["CLIENT_NEWLEAD"];
            this.clientNewPolicy = res["CLIENT_NEWPOLICY"];
            this.clientNewClient = res["CLIENT_NEWCLIENT"];
            this.clientConsultation = res["CLIENT_CONSULTCLIENT"];
            this.clientModification = res["CLIENT_CLIENTMODIFICATION"];
        });
    }

    public reset() {
        this.wizard = {};
        this.selectedControl = null;
        this.referentials = null;

        this.wizard.Steps = {
            "1": {
                "Code": "1",
                "Text": "Client Details",
                "Codes": [],
                "GroupCodes": [],
                "Controls": {},
                "ControlGroups": {},
                "Type": "Standard"
            }
        };

        this.selectedStep = this.wizard.Steps["1"];
    }



    //validate for all steps at the time of submit
    validateControls(wizard) {

        this.requiredControls = [];
        for (var stepKey in this.wizard.Steps) {
            for (var groupKey in this.wizard.Steps[stepKey].ControlGroups) {
                if (!this.wizard.Steps[stepKey].ControlGroups[groupKey].IsMultiline) {

                    for (var controlKey in this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                        if (this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferVisible.Value == true &&
                            this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferRequired.Value == true &&
                            !this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Value) {
                            this.requiredControls.push(this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Text)
                        }
                    }
                }
                else {
                    for (var controlKey in this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls) {
                        if (this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferVisible.Value == true &&
                            this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Properties.OfferRequired.Value == true &&
                            this.wizard.Steps[stepKey].ControlGroups[groupKey].LineCodes.length == 0) {
                            this.requiredControls.push(this.wizard.Steps[stepKey].ControlGroups[groupKey].Controls[controlKey].Text)
                        }
                    }
                }
            }
        }
        
        if (this.wizard.IsDocument == true) {
            for (var docKey in this.wizard.Documents) {
                if (this.wizard.Documents[docKey].IsMandatory &&
                    (this.wizard.Documents[docKey].Image == null || this.wizard.Documents[docKey].Image == ""))
                {
                    this.requiredControls.push(this.wizard.Documents[docKey].DocumentTypeText)
                }
            }
        }

        return this.requiredControls.length;
    }


  
}
